import script from "./ResumenEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenEvento.vue?vue&type=script&setup=true&lang=js"

import "./ResumenEvento.vue?vue&type=style&index=0&id=359febe9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359febe9"]])

export default __exports__